import { tWithKeyAttr as t } from "../../../i18nHelper";
import loginStyles from "../../../pages/login/login.module.css";
import { Link, useNavigate } from "react-router-dom";
import { useSendCodeWithoutLoginMutation } from "../../../services/api/auth.api";
import { useAppSelector } from "../../../services/hooks";
import { errorUserSelector } from "../../../services/selectors/auth.selectors";
import { useActions } from "../../../services/hooks/useActions";
import { useFormik } from "formik";
import { loginSMSValidationSchema } from "../../../utils/validation";
import { TSendCodeWithoutLoginRequest } from "../../../services/types/auth.types";
import { userSelector } from "../../../services/selectors/user.selectors";

function LoginSmsForm({ from }: { from: string }) {
  const navigate = useNavigate();
  const { setPhone } = useActions();

  const user = useAppSelector(userSelector);
  const loginError =
    useAppSelector(errorUserSelector) || t('SUPPORT_UPDATE_ERROR');

  const [sendCodeWithoutLogin, { isError, status }] =
    useSendCodeWithoutLoginMutation();

  const formik = useFormik<TSendCodeWithoutLoginRequest>({
    initialValues: {
      phone: user.phone || "",
      roleId: "1",

      code: "0",
    },
    validationSchema: loginSMSValidationSchema(),
    onSubmit: (values, { setSubmitting }) => {
      // Handle form submission
      setPhone(values.phone);
      sendCodeWithoutLogin(values).then((response) => {
        if ("data" in response && response.data.success) {
          navigate("enter_code", { state: { from } });
        }
      });
      setSubmitting(false);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className={loginStyles.login__form}>
      <p className={loginStyles.login__formText}>{t('TEXT_MESSAGE_SENT_TO_YOUR_PHONE')}</p>
      <label htmlFor="name" className={loginStyles.login__label}>
        {t('MY_MOBILE_NUMBER')}</label>
      <input
        type="tel"
        className={`${loginStyles.login__input} ${loginStyles.login__input_type_phone}  ${formik.errors.phone && loginStyles.login__input_invalid
          }`}
        name="phone"
        required={true}
        placeholder={t('MOBILE_NUMBER')}
        value={formik.values.phone}
        onChange={(e) => {
          // Allow only '+' and digits, max length 16 to cover E.164
          const sanitized = e.target.value.replace(/[^+\d]/g, "");
          if (/^\+?\d*$/.test(sanitized) && sanitized.length <= 16) {
            formik.setFieldValue("phone", sanitized);
          }
        }}
        onBlur={formik.handleBlur}
      />
      {formik.errors.phone && (
        <p className={`${loginStyles.login__invalid_message}`}>
          {t(formik.errors.phone)}
        </p>
      )}
      {isError && (
        <p className={`${loginStyles.login__invalid_message}`}>{loginError}</p>
      )}
      <Link
        to={"/restore_password"}
        className={loginStyles.login__restorePasswordLink}
      />
      {/*שכחת את המספר משתמש שלך?*/}
      {/*</Link>*/}
      <button
        type="submit"
        disabled={
          !formik.values.phone ||
          !formik.isValid ||
          formik.isSubmitting ||
          status === "pending"
        }
        className={`button ${loginStyles.login__button} ${!formik.values.phone ||
            !formik.isValid ||
            formik.isSubmitting ||
            status === "pending"
            ? loginStyles.login__button_disabled
            : "hover"
          }`}
      >
        {status === "pending" ? t('SENDING') : t('ENTRANCE')}
      </button>
    </form>
  );
}

export default LoginSmsForm;
